import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { X, ChevronRight } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '../ui/sheet';
import { Button } from '../ui/button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import LanguageSwitcher from '../LanguageSwitcher';

const MobileMenu = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const categories = [
    { slug: 'chaquetas', name: t('categories.chaquetas') },
    { slug: 'abrigos', name: t('categories.abrigos') },
    { slug: 'blazer', name: t('categories.blazer') },
    { slug: 'camisas', name: t('categories.camisas') },
    { slug: 'denim', name: t('categories.denim') },
    { slug: 'pantalones', name: t('categories.pantalones') },
  ];

  return (
    <Sheet open={isOpen} onOpenChange={onClose}>
      <SheetContent side="left" className="w-[300px] sm:w-[400px] p-0">
        <SheetHeader className="border-b p-4">
          <div className="flex items-center justify-between">
            <SheetTitle>
              <img 
                src="/logo-cimonamia.png" 
                alt="Cimonamia Logo" 
                className="h-8 w-auto"
              />
            </SheetTitle>
            <LanguageSwitcher />
          </div>
        </SheetHeader>

        <div className="flex flex-col h-[calc(100vh-80px)] overflow-y-auto">
          <nav className="flex-1 p-4">
            {/* Home */}
            <Link
              to="/"
              onClick={onClose}
              className="flex items-center justify-between py-3 px-4 hover:bg-gray-50 rounded-lg transition-colors"
            >
              <span className="font-medium text-[#2C2420]">{t('nav.home')}</span>
              <ChevronRight className="h-5 w-5 text-gray-400" />
            </Link>

            {/* Shop with Categories */}
            <Accordion type="single" collapsible className="w-full">
              <AccordionItem value="shop" className="border-none">
                <AccordionTrigger className="py-3 px-4 hover:bg-gray-50 rounded-lg hover:no-underline">
                  <span className="font-medium text-[#2C2420]">{t('nav.shop')}</span>
                </AccordionTrigger>
                <AccordionContent className="pb-0">
                  <div className="pl-4 space-y-1">
                    {categories.map((category) => (
                      <Link
                        key={category.slug}
                        to={`/shop/${category.slug}`}
                        onClick={onClose}
                        className="block py-2 px-4 text-sm text-gray-600 hover:text-[#be1f1a] hover:bg-gray-50 rounded-lg transition-colors"
                      >
                        {category.name}
                      </Link>
                    ))}
                    <Link
                      to="/shop"
                      onClick={onClose}
                      className="block py-2 px-4 text-sm font-medium text-[#be1f1a] hover:bg-gray-50 rounded-lg transition-colors"
                    >
                      {t('categories.allCategories')}
                    </Link>
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>

            {/* About */}
            <Link
              to="/about"
              onClick={onClose}
              className="flex items-center justify-between py-3 px-4 hover:bg-gray-50 rounded-lg transition-colors"
            >
              <span className="font-medium text-[#2C2420]">{t('nav.about')}</span>
              <ChevronRight className="h-5 w-5 text-gray-400" />
            </Link>
          </nav>

          {/* Bottom Actions */}
          <div className="border-t p-4 space-y-2">
            <Link to="/account" onClick={onClose}>
              <Button className="w-full bg-[#be1f1a] hover:bg-[#a71b17] text-white">
                {t('nav.account')}
              </Button>
            </Link>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileMenu;